import { cn } from '@/lib/utils';

type Props = {
  label: string;
  className?: string;
};

const LoadingText = ({ label, className }: Props) => {
  return (
    <span className={cn('inline-flex loading-text-gradient font-bold', className)}>
      <span>{label}</span>
      <span
        className="after:inline-block after:animate-ellipsis after:content-['\u00a0\u00a0\u00a0']"
        aria-hidden
      />
    </span>
  );
};

export default LoadingText;
